import clsx from 'clsx'
import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {STORE_BUILD_UNAVAILABLE_TEXT} from '../../install-app/core/androidApp'

/**
 * Where a fee, a charge or a payment would be, in the Bazaar and Myket builds of the Android app (hidesPayments): one
 * plain sentence, with no price and no other way to pay.
 */
export const StoreBuildUnavailableNote: FC<{className?: string}> = ({className}) => (
  <span className={clsx('text-muted fs-7', className)} role='note'>
    <i className='las la-info-circle me-1' aria-hidden='true'></i>
    {STORE_BUILD_UNAVAILABLE_TEXT}
  </span>
)

/** The same as a dialog, in place of a confirmation or a charge window. */
export const StoreBuildUnavailableDialog: FC<{title?: string; onClose: () => void}> = ({title, onClose}) => (
  <Modal show centered onHide={onClose} aria-labelledby='store-build-unavailable-title'>
    <Modal.Header closeButton closeLabel='بستن'>
      <Modal.Title id='store-build-unavailable-title' as='h2' className='fs-4'>
        {title || 'در دسترس نیست'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className='mb-0'>{STORE_BUILD_UNAVAILABLE_TEXT}</p>
    </Modal.Body>
    <Modal.Footer>
      <button type='button' className='btn btn-primary' onClick={onClose}>
        بستن
      </button>
    </Modal.Footer>
  </Modal>
)
